import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';
import { Card } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { PAGE_NAMES, MISCELLANEOUS_RESOURCES } from 'constant';
import { URL, LABEL, IMAGE_SOURCE } from './helper';

const useMiscellaneousHome = () => {
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const isEnabled = (configResourceName: string) => {
		return hasPermissionV2({
			configPageName: PAGE_NAMES.miscellaneous,
			configResourceName
		});
	};

	return { isEnabled };
};

const MiscellaneousHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useMiscellaneousHome();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-evenly',
				alignItems: 'center',
				height: '45%',
				flexWrap: 'wrap',
				gap: '25px'
			})}>
			{_map(_keys(MISCELLANEOUS_RESOURCES), (resourceName) => {
				return isEnabled(resourceName) ? (
					<div
						key={resourceName}
						className={css({
							height: '130px',
							width: '40%',
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-around'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[resourceName]);
						}}>
						<Card label={LABEL[resourceName]} img={IMAGE_SOURCE[resourceName]} />
					</div>
				) : null;
			})}
		</div>
	);
};

export default MiscellaneousHome;
